var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 24,
    viewBox: "0 0 39 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.39478,
    y: 6.3158,
    width: 1.12283,
    height: 11.2283,
    fill: "current"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0084,
    y: 6.31573,
    width: 1.12283,
    height: 11.2283,
    fill: "current"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4827,
    y: 6.31573,
    width: 1.12283,
    height: 11.2283,
    fill: "current"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26.2368,
    y: 6.31573,
    width: 1.12283,
    height: 11.2283,
    fill: "current"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6226,
    y: 6.31573,
    width: 4.49132,
    height: 11.2283,
    fill: "current"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2543,
    y: 6.31573,
    width: 2.24566,
    height: 11.2283,
    fill: "current"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11.64,
    y: 6.31573,
    width: 2.24566,
    height: 11.2283,
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/barcode.ce2fd0bfe0b1cb570b9838e54454e110.svg";
export { ForwardRef as ReactComponent };